module.exports = __webpack_public_path__ + "fonts/3cbe925.ttf";